<div class="status">
  <p-progressSpinner strokeWidth="4" ariaLabel="loading" />
    <h4 class="status-message">{{statusMessage}}</h4>
</div>
<p-progressBar [value]="completionPercentage">
  <ng-template pTemplate="content" let-value>
  </ng-template>
</p-progressBar>
<i class="small centered">Render credits are only deducted once a successful render has been received by RoRender.com.</i>
<p-divider />
<div class="pipeline-info">
  <h4 class="title">Render Pipeline ID</h4>
  <p-inputGroup>
    <input type="text" (focus)="focused()" pInputText placeholder="Keyword" [autofocus]="false" [readOnly]="true" [ngModel]="renderPipelineId" />
    <button type="button" pButton icon="pi pi-copy" (click)="copyToClipboard()"></button>
  </p-inputGroup>
  <i class="small">Copy this ID into the plugin in order to upload render data to this website</i>
</div>
<p-button
  icon="pi fi fi-rr-circle-xmark"
  [rounded]="true"
  [disabled]="renderCancelled"
  label="Cancel Render"
  severity="danger"
  outlined
  (onClick)="closePipeline()"
/>
